<template>
  <div>
    <el-form
      :model="form"
      :rules="rules"
      ref="resetForm"
      label-position="left"
      style="margin: 0px 40px"
    >
      <el-form-item label="用户名：" class="same">
        <el-input :value="loginName" disabled></el-input>
      </el-form-item>
      <el-form-item label="新密码：" class="same" prop="userPassword">
        <el-input v-model="form.userPassword" show-password></el-input>
      </el-form-item>
      <el-form-item label="确认密码：" class="same" prop="confirmPassword">
        <el-input v-model="form.confirmPassword" show-password></el-input>
      </el-form-item>
      <span class="tip">
        提示：密码不符合规则，需包含大写字母、小写字母、数字、特殊字符中的任意三种，长度在12至20
      </span>
    </el-form>
    <div style="text-align: center;margin-top:50px">
      <el-button style="width: 200px" type="primary" @click="commandConfirm"
        >确认</el-button
      >
    </div>
  </div>
</template>

<script>

export default {
  props: {
    loginName: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      form: {
        userPassword: "",
        confirmPassword: "",
      },
      rules: {
        userPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    commandConfirm(){
        let that = this;
        this.$refs["resetForm"].validate((valid) => {
            if (valid) {
                let { userPassword, confirmPassword } = that.form;
                if (userPassword != confirmPassword) {
                    that.$message({
                        type: "warning",
                        message: "两次输入密码不相同，请重新输入",
                    });
                    return;
                }

                this.$emit('call',this.form)
            }
        })
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tip{
    display: inline-block;
    color: #f00;
    font-size: 12px;
    text-align: left;
    margin-top: 15px;
}
.same{
    margin-bottom: 10px!important;
}
</style>